import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router';

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 20000,
  paramsSerializer: {
    serialize: (params) => {
      const searchParams = new URLSearchParams();
      for (const key in params) {
        const value = params[key];
        if (value === undefined || value === null) continue;
        if (Array.isArray(value)) {
          value.forEach(item => {
            if (item !== undefined && item !== null) {
              searchParams.append(key, item);
            }
          });
        } else {
          searchParams.append(key, value);
        }
      }
      return searchParams.toString();
    }
  }
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => {
    const res = response.data;
    const code = (res && typeof res === 'object') ? (res.code !== undefined ? res.code : 0) : 0;
    const msg = (res && typeof res === 'object') ? (res.message || res.msg || '系统未知错误') : '系统未知错误';
    
    // 如果是二进制数据则直接返回
    if (response.request.responseType === 'blob' || response.request.responseType === 'arraybuffer') {
      return res;
    }
    
    // 假设业务成功 code 为 0 或 200
    if (code !== 0 && code !== 200) {
      // 调用方可通过 config.skipErrorMessage = true 跳过全局弹窗，自行处理错误
      if (!response.config.skipErrorMessage) {
        Message({
          message: msg,
          type: 'error',
          duration: 5 * 1000
        });
      }
      return Promise.reject(new Error(msg));
    }
    return res;
  },
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }
    // 401：token 不存在或已失效，清除本地 token 并跳转登录页
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      Message({ message: '登录已过期，请重新登录', type: 'warning', duration: 2000 });
      if (router.currentRoute.path !== '/login') {
        router.replace('/login');
      }
      return Promise.reject(error);
    }

    let message = error.message;
    if (error.response && error.response.data && (error.response.data.message || error.response.data.msg)) {
      message = error.response.data.message || error.response.data.msg;
      // 5xx 错误时若响应含 traceId 且消息未包含，则追加便于用户反馈给管理员
      if (error.response.status >= 500 && error.response.data.traceId && message.indexOf('追踪号') === -1) {
        message += '（追踪号：' + error.response.data.traceId + '，请提供给管理员排查）';
      }
    } else if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }

    if (!(error.config && error.config.skipErrorMessage)) {
      Message({
        message: message,
        type: 'error',
        duration: 5 * 1000
      });
    }
    return Promise.reject(error);
  }
);

export default http;
